// extracted by css-extract-rspack-plugin
export default {"wrapper":"_91a05ec0","disableProjectsOverlay":"_bd0d72db"};